<app-offcanvas-base [returnUrl]="returnUrl">
  <ng-container title>
    <app-offcanvas-header-btn title="Invited employee details"></app-offcanvas-header-btn>
  </ng-container>
  <ng-container body>
    <app-invited-employee-form class="offcanvas-body-inner" />
  </ng-container>
</app-offcanvas-base>
